import React from 'react';
import styled from 'styled-components';
import { Asset } from '../../app';
import { Text } from '../../components';
import { breakpoints, spacings } from '../../styles';

const Root = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: ${breakpoints.s}) {
    flex-direction: column;
  }
`;

const Message = styled(Text)`
  flex: 1;
  padding-right: ${spacings.s};

  @media (max-width: ${breakpoints.s}) {
    padding-right: 0;
    padding-bottom: ${spacings.s};
    text-align: center;
  }
`;

interface ShieldPromptProps {
  asset: Asset;
  balance: bigint;
  pendingValue: bigint;
  pendingBalance: bigint;
  onSubmit: () => void;
}

export const ShieldPrompt: React.FunctionComponent<ShieldPromptProps> = ({ asset }) => {
  return (
    <Root>
      <Message size="m">Shielding of {asset.symbol} has been disabled.</Message>
    </Root>
  );
};
